import { Component } from '@angular/core';
import { breadcrumb, link, stat } from '../../layout/header/header.component';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import icons from '../../../misc/data/icons.json';
import {
  ConfirmEventType,
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
  SelectItem,
  TreeDragDropService,
  TreeNode,
} from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { ImageUploadQuestion } from 'src/app/misc/component/dynamic-form/question-imageupload';
import { RadioButtonQuestion } from 'src/app/misc/component/dynamic-form/question-radiobutton';
import cloneDeep from 'lodash/cloneDeep';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DisabledQuestion } from 'src/app/misc/component/dynamic-form/question-disabled';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { IconBoxQuestion } from 'src/app/misc/component/dynamic-form/question-iconbox';

@Component({
  selector: 'app-organization-units',
  templateUrl: './organization-units.component.html',
  styleUrls: ['./organization-units.component.scss'],
  providers: [TreeDragDropService, ConfirmationService, MessageService],
})
export class OrganizationUnitsComponent {



  header = this.translate('Ou Management Page');
  links: link[] = [
    {
      name: this.translate('Categories'),
      icon: 'pi pi-sitemap',
      link: '/admin/organization-units/categories',
      visible: this.permissionService.hasPermission("OU_CATEGORY", "r")
    },
    {
      name: this.translate('species'),
      icon: 'pi pi-list',
      link: '/admin/organization-units/types',
      visible: this.permissionService.hasPermission("OU_TYPE", "r")
    },
    {
      name: this.translate('the cities'),
      icon: 'pi pi-map-marker',
      link: '/admin/organization-units/locations',
      visible: this.permissionService.hasPermission("OU_LOCATION", "r")
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Ou Management Page'), link: '/admin/organization-units' },
  ];
  stats: stat[] = [];
  messages: Message[] = [];
  ous: OrganizationUnit[] = [];
  skelition: boolean = true;
  currentParent: any = null;
  showCreateModal: boolean = false;
  iconOptions: SelectItem[] = [];
  data: any[] = [];
  treeDDData: TreeNode[] = [];
  showAddManagers: boolean = false;
  treedata: TreeNode[] = [];
  staticURL = GlobalConstants.staticFilesURL;
  menuitems: MenuItem[] = [
    {
      label: 'جدول',
      icon: 'pi pi-fw pi-home',
      command: (event) => {
        this.onActiveItemChange(event);
      },
    },
  ];

  activeItem: MenuItem = {};

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;
  createPermission: boolean = false;
  updatePermission: boolean = false;
  deletePermission: boolean = false;

  allowdOusToCreateIn: any[] = [];
  allowdOusToUpdateIn: any[] = [];
  allowdOusToDeleteIn: any[] = [];
  userManagemenetPermission: boolean = false;

  categories: any[] = [];
  types: any[] = [];
  fromTree: Boolean = false;
  cities: any[] = [];
  tags: any[] = [];
  loadingSelected: boolean = false;

  selectedid: any = null;

  selectedTreeTags: MenuItem[] = [];
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  createtypequestions: QuestionBase<string>[] = [];
  showCreateType: boolean = false;

  createou: any = { name: '', image: '' }
  showCreateOu: any;
  apilink = GlobalConstants.apiURL;
  translator: TranslatorPipe = new TranslatorPipe()
  loading: boolean = false
  maxId: number = 0;
  ouQuestions: QuestionBase<string>[] = [];
  isIcon: any;
  allowedCreateTag: string[] = [];
  allowedUpdateTag: string[] = [];
  allowedDeleteTag: string[] = [];
  currentTag: string = "";

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private orgUnits: OrgUnitsService,
    private permissionService: PermissionHandlerService,
  ) { }

  onActiveItemChange(event: any) {
    console.log(event.item.label);
    this.activeItem = event.item;
  }

  onImageUpload(event: any) {
    this.createou.image = event.originalEvent.body.data;
  }

  async clean() {
    let cleanres = await this.dataService.getData('ou/clean');
  }


  async addManagers(event: any) {
    this.showAddManagers = false;
    if (event.emit && this.updateData) {
      this.updateData.managers = event.users.map((u: any) => u._id);
      await this.UpdateData();
      window.location.reload()
    }
  }

  checkTagPermission(tags: string[], tag: any): boolean {
    if (typeof tag == 'string') {
      return tags.includes(tag);
    } else {
      return tags.includes(tag.label)
    }
  }


  async setupCreateOu(node: any, tag?: string, icon = false) {

    if (tag) this.currentTag = tag

    this.showCreateOu = true;
    this.currentParent = node;
    console.log("NODE", node);



    this.createou = {
      "name": "",
      "parent": node.id == null ? null : node,
      "type": node.id == null ? node : null,
      "location": null,
      "active": true,
      "id": this.maxId,
    }



    this.createou.category = this.categories[0]?._id;

    console.log("this.categories", this.categories)
    if (tag != 'Branches') {
      this.createou.location = this.cities[0]._id;
    }
    if (tag) {
      await this.makeOuquestion(tag, icon);
    } else {
      await this.makeOuquestion();
    }

  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  createOuSubmit = async ($event: any) => {
    try {
      this.loading = true
      if (typeof $event === 'string') {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: $event },
        ];
        this.loading = false
        return;
      }
      let data = $event;
      delete data.icontype;
      if (data.parent) {
        if (data.parent.label == 'الجهات المشاركة') {
          data.parent = null;
        } else {
          data.parent = data.parent;
        }

      } else delete data.parent;

      if (data.icon) {
        data.image = data.icon;
        data.image_sq = data.icon;
      }

      delete data.icon;

      if (this.updateData != undefined && this.updateData != null) {
        data._id = this.updateData._id;
      }
      let res = await this.dataService.postData('ou', data, this.updateData ? 'PUT' : 'POST');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        this.loading = false
        return;
      }
      this.loading = false
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.showCreateOu = false;
      window.location.reload()
    } catch (error) {
      console.log(error);
    }
  };

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }
    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }
    return null; // Exclude this node from the result
  }


  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    if (this.selectedTreeData.length == 0) {

      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });
      this.selectedTreeData = cloneDeep(cloneitems);
    }
  }

  async changeSelectedTag(event: any) {
    this.selectedTreeTags_current = event;
    if (event && event.label) {

      await this.filterTreeByTag(event.label);
    } else {
      this.selectedTreeData = null;
    }

  }

  openCreateModal(parent: any) {
    this.currentParent = parent;
    this.showCreateModal = true;
  }

  closeCreateModal(item: any) {
    this.showCreateModal = false;

    if (item) {
      window.location.reload();
    }
    this.currentParent = null;
  }

  ngOnInit() {
    this.fromTree = false;
    this.selectedTreeData = [];
    this.skelition = true;

    this.activeItem = this.menuitems[0];
    this.completeAsyncCallsConsectively();
    this.createPermission = this.permissionService.hasPermission("OU", "c");
    this.updatePermission = this.permissionService.hasPermission("OU", "u");
    this.deletePermission = this.permissionService.hasPermission("OU", "d");
    this.userManagemenetPermission = this.permissionService.hasPermission("USER_MANAGEMENT", "r");
    this.allowedCreateTag = this.permissionService.extractTags('OU_TYPE', 'c');
    this.allowedDeleteTag = this.permissionService.extractTags('OU_TYPE', 'd');
    this.allowedUpdateTag = this.permissionService.extractTags('OU_TYPE', 'u');
    console.log('ALLOWED CREATE', this.allowedCreateTag)
    this.getAllowedOus();

    this.maketypequestion();
  }

  async getAllowedOus() {
    Promise.all([
      this.permissionService.extractOUChildrenWithInactive('OU', 'c'),
      this.permissionService.extractOUChildrenWithInactive('OU', 'u'),
      this.permissionService.extractOUChildrenWithInactive('OU', 'd')
    ]).then(([createPermission, updatePermission, deletePermission]) => {
      this.allowdOusToCreateIn = createPermission;
      this.allowdOusToUpdateIn = updatePermission;
      this.allowdOusToDeleteIn = deletePermission;
    })
  }

  checkPermission(allowedOus: any, node: any) {
    //console.log(allowedOus);
    if (allowedOus.length > 0 && node != undefined) {
      if (node._id != null && node._id != undefined) {
        return this.permissionService.checkOUPermissionByIDWithOus(node._id, allowedOus);
      } else {
        return this.permissionService.checkOUPermissionByLabelWithOus(node.label, allowedOus);
      }
    }
    return false;
  }

  async completeAsyncCallsConsectively() {
    this.fromTree = false;
    await this.getData();
    Promise.all([
      this.getCity(),
      this.getTypes(),
      this.getCategory(),
      this.getTreeData(),
    ]).then((e) => {
      this.skelition = false;
    });
  }

  allowedRight = ['Ministries/Entities', 'Organisational Units']



  findNodeByName(data: any[], nodeName: string): any | undefined {
    for (const node of data) {
      if (node._id === nodeName) {
        return node;
      }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  selectedTreeData: any = []
  dataForUpadte: any = []

  async selectedTab(id: any) {
    this.loadingSelected = true;
    let data = await this.orgUnits.getOrgUnitsWithInactive()
    this.selectedTreeData = []
    this.selectedid = id.node;

    console.log()
    if (this.selectedid.label != 'الجهات المشاركة') {

      this.selectedTreeData.push(this.findNodeByName(data, id.node._id))
      // Create a deep copy of the selected data using lodash.clonedeep
      this.selectedTreeData_orginal = cloneDeep(this.selectedTreeData);
      console.log("the selected tree", this.selectedTreeData);

      const uniqueTags = new Set()

      this.types.forEach((type: any) => {
        if (type && type.tag) {

          uniqueTags.add(type.tag);
        }
      });

      let uniqueTagsArray: MenuItem[] = []

      uniqueTags.forEach((item: any) => {
        if (item != "Ministries/Entities")
          uniqueTagsArray.push({ label: item });
      })

      this.selectedTreeTags = uniqueTagsArray;

      this.selectedTreeTags_current = this.selectedTreeTags[0]

      this.changeSelectedTag(this.selectedTreeTags_current);

    }


    this.loadingSelected = false;
  }

  async getTreeData() {
    this.dataForUpadte = await this.orgUnits.getOrgUnitsWithInactive()
    this.treeDDData = await this.orgUnits.getOrgUnitsMainPage(this.allowedRight);
    console.log('TREE DATA', this.treeDDData);
  }

  async getUpdatedOus() {
    this.treeDDData = await this.orgUnits.getOrgUnitsMainPage(this.allowedRight);
    console.log('TREE DATA', this.treeDDData);
  }

  async getData() {
    await this.fetchOus();
    console.log(this.ous);
    this.ous.forEach((item: OrganizationUnit) => {
      this.data.push({
        '#': { n: item._id, i: 'pi pi-angle-left' },
        'وحدة التنظيم': { n: item.name, i: item.image_sq },
      });

      if (item.parent) {
        this.data[this.data.length - 1]['الصنف الأب'] = {
          n: item.parent.name,
          i: item.parent.image_sq,
        };
      } else {
        this.data[this.data.length - 1]['الصنف الأب'] = {
          n: 'الجهات المشاركة',
          i: '/public/ous/19eac9488f9377b374788d8ea91d7be7.png',
        };
      }

      if (item.type) {
        this.data[this.data.length - 1]['النوع'] = {
          n: item.type.name,
          i: item.type.icon,
        };
      }

      if (item.category) {
        this.data[this.data.length - 1]['التصنيف'] = {
          n: item.category.name,
          i: item.category.icon,
        };
      }

      // if(item.location){
      this.data[this.data.length - 1]['المدينة'] = {
        n: item.location?.name ? item.location?.name : 'غير معرف',
        i: 'pi pi-map-marker',
      };

      this.data[this.data.length - 1]['مدير'] = {
        n: item.isManager,
        i: item.isManager ? 'pi pi-check-circle' : 'pi pi-times-circle',
      };

      this.data[this.data.length - 1]['الحالة'] = {
        n: item.active,
        i: item.active ? 'pi pi-check-circle' : 'pi pi-times-circle',
      };

      this.data[this.data.length - 1]['Action'] = [
        {
          n: 'Delete',
          i: 'pi pi-times',
          s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
        },
        {
          n: 'Update',
          i: 'pi pi-file-edit',
          s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
        },
      ];
    });
    this.updateOUCounts();
  }

  private async fetchOus(): Promise<void> {
    let res = await this.dataService.getData('ou');
    if (res.error) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: res.msg },
      ];
      return;
    }

    this.maxId = Math.max(...res.data.map((o: any) => o.id)) + 1;
    this.ous = res.data as OrganizationUnit[];
    this.updateOUCounts();
  }

  findAll(name: string) {
    var children: TreeNode[] = [];

    var temp = this.ous.filter((item: OrganizationUnit) => {
      return item.parent?.name == name;
    });

    if (temp.length > 0) {
      temp.forEach((item: OrganizationUnit) => {
        children.push({
          label: item.name,
          data: item.image_sq,
          children: this.findAll(item.name),
        });
      });
    }

    return children;
  }

  async UpdateData() {
    this.skelition = true;
    try {
      let data = {
        _id: this.updateData._id,
        name: this.updateData.name,
        parent: this.updateData.parent,
        category: this.updateData.category._id,
        type: this.updateData.type._id,
        location: this.updateData.location._id,
        image: this.updateData.image,
        image_sq: this.updateData.image_sq,
        isManager: this.updateData.isManager,
        managers: this.updateData.managers,
        active: this.updateData.active,
        id: this.updateData.id,
      };


      let res = await this.dataService.postData('ou', data, 'PUT', false);
      await this.dataService.getData("ou/clean");
      await this.dataService.postData('user/make-manager', { ouId: data._id, userIds: data.managers }, 'PUT', false);
      this.skelition = false;
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: 'خطأ', detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateModal = false;
      this.updateData = undefined;

      if (this.fromTree) {
        this.getUpdatedOus()
      }
      this.selectedTreeData = [];
      this.updateOUCounts();
    } catch (e) {
      console.log(e);
    }
  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.cities = res.data.map((location: any) => {
          return {
            _id: location._id,
            name: location.name,
            icon: 'pi pi-map-marker',
          };
        });
        console.log('this.cities =>', this.cities);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getCategory() {
    try {
      let res = await this.dataService.getData('ou-category');
      if (!res.error) {
        this.categories = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getTypes() {
    try {
      let res = await this.dataService.getData('ou-type');
      if (!res.error) {
        this.types = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  getIcons() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });
  }



  actionCall($event: any) {
    console.log('ACTION', $event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: 'سيتم حذف جميع البيانات الموجودة، هل أنت متأكد من أنك تريد حذف هذا؟',
          header: 'رسالة التأكيد',
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id, $event.tree),
        });
        break;
      case 'Create':
        this.openCreateModal($event.parent);
        break;
      case 'Update':
        this.updateData = this.ous.find((item) => item._id == $event.id);
        this.fromTree = true;
        console.log(this.updateData);
        if (this.updateData.parent && this.updateData.parent != null) {
          this.updateData.parent.label = this.updateData.parent.name;
        }

        this.showCreateModal = true;
        this.updateModal = true;
        break;
      case 'Add Managers':
        this.updateData = this.ous.find((item) => item._id == $event.id);
        this.showAddManagers = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string, fromTree: boolean = false) => {
    try {
      let res = await this.dataService.deleteData(`ou/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      window.location.reload();
      // this.data = this.data.filter((item) => item['#'].n !== id);
      // this.ous = this.ous.filter((item) => item._id !== id);
      // if (fromTree) {
      //   this.getUpdatedOus()
      // }
      // this.updateOUCounts();
      // this.selectedTreeData = [];
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateOUCounts(): void {
    console.log(this.data.length);
    let activeCategories = this.data.filter(
      (item) => item['الحالة'].n === true
    ).length;
    let inactiveCategories = this.data.length - activeCategories;
    this.stats = [
      {
        name: this.translate('active'),
        number: activeCategories,
        icon: 'pi pi-check-circle',
      },
      {
        name: this.translate('Inactive'),
        number: inactiveCategories,
        icon: 'pi pi-times-circle',
      },
    ];
  }

  maketypequestion() {
    this.getIcons();
    this.createtypequestions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم النوع',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new IconBoxQuestion({
        key: 'icon',
        label: 'الايقونات',
        required: true,
        order: 3,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DisabledQuestion({
        key: 'tag',
        label: 'علامة',
        type: 'text',
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value: "Ministries/Entities"
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 5,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: "false"
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      let res = await this.dataService.postData('ou-type', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
    } catch (error) {
      console.log(error);
    }
  };

  makeOuquestion(tag?: string, icon = false) {

    let types: any;

    if (tag) {

      types = this.types.filter((item) => item.tag == tag)
    } else {
      types = this.types;
    }

    console.log('UPDATE DATA', this.updateData);
    this.ouQuestions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم الوحدة التنظيمية',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        value: this.createou?.name
      }),

      this.createou && this.createou.location ? new DisabledQuestion({
        key: 'location',
        label: 'المدينة',
        type: 'text',
        order: 2,
        value: this.createou?.location,
        visibility: "false"
      }) : new DropdownQuestion({
        key: 'location',
        label: 'المدينة',
        options: this.cities.map((item) => {
          return {
            label: item.name,
            value: item._id,
            icon: item.icon,
          };
        }),
        order: 2,
        filter: true,
        value: this.createou?.location
      }),

      this.createou && this.createou.category ? new DisabledQuestion({
        key: 'category',
        label: 'التصنيف',
        type: 'text',
        order: 3,
        value: this.createou?.category,
        visibility: "false"
      }) : new DropdownQuestion({
        key: 'category',
        label: 'التصنيف',
        options: this.categories.map((item) => {
          return {
            label: item.name,
            value: item._id,
            icon: `pi pi-${item.icon}`,
          };
        }),
        order: 3,
        value: this.createou?.category
      }),

      this.createou && this.createou.type ? new DisabledQuestion({
        key: 'type',
        label: 'النوع',
        type: 'text',
        order: 4,
        value: this.createou?.type._id,
        valueShow: this.createou?.type.label,
        visibility: "true"
      }) : new DropdownQuestion({
        key: 'type',
        label: 'النوع',
        options: types.map((item: { name: any; _id: any; icon: any; }) => {
          return {
            label: item.name,
            value: item._id,
            icon: `pi pi-${item.icon}`,
          };
        }),
        order: 4,
        value: this.createou.type ? this.createou.type : (types.length == 1 ? types[0]._id : null)
      }),

      new DisabledQuestion({
        key: 'parent',
        label: 'الصنف الأب',
        type: 'text',
        order: 5,
        value: this.createou && this.createou.parent ? this.createou.parent._id : null,
        valueShow: this.createou && this.createou.parent ? this.createou.parent.label : "الجهات المشاركة",
        visibility: "true"
      }),

      new RadioButtonQuestion({
        key: 'icontype',
        label: 'نوع الشعار',
        options: [
          { label: 'صورة', icon: 'pi pi-image', value: false },
          { label: 'ايقونة', icon: 'pi pi-flag', value: true },
        ],

        className: 'col-md-6 col-sm-6 col-12',
        order: 6,
        value: icon
      }),

      new ImageUploadQuestion({
        key: 'image',
        label: 'الصورة',
        order: 9,
        isImage: true,
        required: false,
        className: 'col-md-12 col-sm-12 col-12',

        visibility: (!icon).toString(),
        value: this.createou.image
      }),

      new ImageUploadQuestion({
        key: 'image_sq',
        label: 'الشعار',
        order: 10,
        isImage: true,
        required: false,
        className: 'col-md-12 col-sm-12 col-12',
        visibility: (!icon).toString(),
        value: this.createou?.image_sq
      }),

      new IconBoxQuestion({
        key: 'icon',
        label: 'الايقونات',
        required: false,

        filter: true,
        order: 15,
        className: 'col-md-12 col-sm-12 col-12',
        visibility: icon.toString(),
        value: this.createou?.image
      }),
    ];
  }

  handleImgTypeChange(val: boolean) {
    this.isIcon = val;

    let iconQuestion = this.ouQuestions.find((e) => e.key == 'icon');
    let imgQuestion = this.ouQuestions.find((e) => e.key == 'image');
    let imgSqQuestion = this.ouQuestions.find((e) => e.key == 'image_sq');

    if (iconQuestion) {
      iconQuestion.visibility = this.isIcon.toString();
    }
    if (imgQuestion) {
      imgQuestion.required = false;
      imgQuestion.visibility = (!this.isIcon).toString();
    }
    if (imgSqQuestion) {
      imgSqQuestion.required = false;
      imgSqQuestion.visibility = (!this.isIcon).toString();
    }
  }
}
